import axiosGlobalInstance from './configHttpInstance/http-instance';
import mockMeDetail from './fakes/me';

const getMe = () => {
  const useFake = !!Number(process.env.REACT_APP_MOCK_API);

  if(useFake) {
    return new Promise((resolve) => {
      setTimeout(() => resolve(mockMeDetail), 500);
    });
  }

  const httpInstance = axiosGlobalInstance();

  return httpInstance({
    method: 'GET',
    url: '/me',
  });
}

export default getMe;
